import React from 'react';
import services from '../../../services';
import TitleBar from '../../../components/common/title_bar';
import { withRouter } from 'react-router-dom';
import SearchFilter from '../../../components/filters/SearchFilter';
import { toast } from 'react-toastify';
import Lang from '../../../lang'
import RevenueModalForm from '../../../components/VidimaModule/Modal/CommonSideModalForm';
import $ from 'jquery'
import TlkTable from '../../../components/tlelrik/table/tlkTable';
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import RevenueEntityAction from '../../../components/common/RevenueEntityAction';
import InstalaCaovinicaTables from './InstalaCaovinicaTables';
import { Button } from '@progress/kendo-react-buttons'
var moment = require('moment')
const dateFormat = "YYYY-MM-DD";

const servicesMenuArray = [
    { "main": "Tx. Aguardente", name: "Taxas referentes à comercialização de aguardente" },
    { "main": "Tx. Vinhos", name: "Taxas referentes à comercialização de vinhos no mercado nacional, estrangeiro e vinho modificado" },
    { "main": "Selos e Cápsulas", name: "Compras de Selos e/ou Cápsulas" },
    { "main": "req. serviços", name: "Requisições de serviço" },
    { "main": "fiscalização", name: "Custos de fiscalização" },
    { "main": "medidas de intervenção", name: "Taxas referentes às Medidas de Intervenção" },
    { "main": "artigos diversos", name: "Artigos diversos", api: "" },
    { "main": "juros de mora", name: "Juros de Mora" },
    { "main": "observações", name: "Observações diversas" },
]

let defaultRequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};
class Common extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filter: this.props.linkData.filters,
            popUpForm: '',
            popUpForm2: null,
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            },
            billing_address: null,
            applyedfilter: {},
            maxDate:'',
            checkedInvoice: [],
            general_balance_row: "",
            date: new Date()
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.createState();
        this.getCurrentGeneralAccount();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            this.createState();
        }
    }

    /* Para criar o estado básico da página no carregamento */

    createState = () => {
        this.setState({
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            },
            filters: this.props.linkData.filters
        })
        let applyedfilter = { ...this.state.applyedfilter };
        if (this.props.parsed.invoice_id) {
            applyedfilter.invoice_id = this.props.parsed.invoice_id
        }
        if (this.props.parsed.entity_id) {
            applyedfilter.entity_id = this.props.parsed.entity_id
        }
        if (applyedfilter.entity_id) {
            this.getEntityDetails(applyedfilter.entity_id);
        }
        console.log("applyedfilter", applyedfilter);
        this.setState({
            applyedfilter
        });

    }


    /**
     * obter conta geral
     */
    getCurrentGeneralAccount = async () => {
        if (this.props.tab === "general_account") {
            let link = "Revenue/GeneralAccount/GetLastDetails"
            let res = await services.apiCall.requestApi(link, {}, "get");
            if (res) {
                this.setState({
                    general_balance_row: res,
                    date: new Date()
                });
            } else {
                this.setState({
                    general_balance_row: {
                        balance: 0,
                        date: new Date()
                    }
                });
            }
        }
    }

    /*Para obter detalhes de uma única entidade usando api */

    getEntityDetails = async (entity_id) => {
        let Request = {};
        console.log("Entityfunction ", Request)
        this.setState({
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            }
        });
        if (!entity_id)
            return
        Request.entityId = parseInt(entity_id);
        let link = "/Revenue/getEntityDetail"
        let res = await services.apiCall.requestApi(link, Request);
        if (res) {
            this.setState({
                entity_details: res
            });
        }
    }


    /* Para obter dados filtrados do componente de filtro personalizado  */

    handleFilter = (data) => {
        // this.setState({
        //     filterData: data
        // }, () => this.createTabel())
    }


    modificaoDateShow = (dateArray) => {
        if(dateArray && dateArray.length > 0){
            let maxDate=moment(new Date(Math.max.apply(null,dateArray))).format("DD/MM/YYYY")
            console.log("ppppppp",maxDate,dateArray)
            this.setState({maxDate})
        }else{
            this.setState({maxDate : ''})
        }
    }



    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    getFilters = (customfilters) => {
        if (customfilters && (Object.keys(customfilters.filters).length === 0 && Object.keys(customfilters.filterCheckbox).length === 0)) {
            this.setState({showSearchMsg : false, maxDate : ''})
            return
        }
        let applyedfilter = { ...customfilters.filterCheckbox, ...customfilters.filters }
        delete applyedfilter.entity;
        applyedfilter.local = window.localStorage.getItem('Local');
        console.log("filter", applyedfilter,"custom filter",customfilters);
        this.setState({
            applyedfilter,
            showSearchMsg:true,
            date: new Date()
        }, () => this.getEntityDetails(applyedfilter.entity_id)
        );
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        console.log(action, row);
        let popUpForm = null;
        let newUrl = null;
        let invoice_id = "";
        if (row.invoice_id) {
            invoice_id = row.invoice_id;
        } else {
            invoice_id = row.id;
        }

        if (action === 'mover para a fatura') {
            newUrl = '/revenue_faturas?u=revenue_faturas&p=Emitir%20Faturas&t=FaturasEmitir' + "&entity_id=" + row.entity_id + "&invoice_id=" + invoice_id;
            this.props.history.push({ pathname: newUrl, state: {} })
            // window.history.pushState({}, null, newUrl);
        } else if (action === "ir para a fatura") {
            newUrl = '/revenue_receitas?u=revenue_receitas&p=Recibos%20de%20Adiantamento&t=TesourariaRecabo' + "&entity_id=" + row.entity_id + "&invoice_id=" + invoice_id;
            this.props.history.push({ pathname: newUrl, state: {} })
            // window.history.pushState({}, null, newUrl);
        } else if (action === 'RedirectTwo') {
            newUrl = '/revenue_receitas?u=revenue_receitas&p=Consulta%20de%20Conta%20corrente&t=TesourariaContacorrente' + "&entity_id=" + row.entity_id + "&invoice_id=" + invoice_id;
            this.props.history.push({ pathname: newUrl, state: {} })
            // window.history.pushState({}, null, newUrl);
        } else if (action === 'Mover de geral para avançado') {
            newUrl = '/revenue_receitas?u=revenue_receitas&p=Recibos%20de%20Adiantamento&t=TesourariaRecabo' + "&entity_id=" + row.entity_id + "&invoice_id=" + invoice_id;
            this.props.history.push({ pathname: newUrl, state: {} })
            // window.history.pushState({}, null, newUrl);
        }
        else if (action === 'Redirect') {
            newUrl = '/revenue_page?name=faturas&type=' + row.trans_msg + "&id=" + row.id + "&entity_id=" + row.busEntidadeDetail.nifap + "&invoice_id=" + invoice_id;
            this.props.history.push({ pathname: newUrl, state: {} })
            // window.history.pushState({}, null, newUrl);
        }
        else if (action == 'Edit') {
            //https://localhost:44397/api/SIVDP/InstalacaoVinica/8
            this.props.history.push({
                pathname: "/inseririnstalacaovínica",
                search : `idInstalacao=${row['detalheURLIDInstalacao'].toString()}&codEntidade=${row['detalheURLCodEntidade'].toString()}&geocodigo=${row['detalheURLGeocodigo'].toString()}`,
                //state: { entidade_id: row.codEntidade, idWS: row['código_de_Instalação'] }
            })
        } else if (action === 'detailPopUp' || action === 'detailPopUpTwo') {
            popUpForm = this.openDetailPopUpForm(row, action);
        }
        else if (action === "checkedInvoice") {
            let checkedInvoice = Object.values(row);
            if (checkedInvoice.length) {
                this.GetInvoiceLink(checkedInvoice);
            }
        } else if (action === "Add_Amount") {
            this.addamountFrom(action, row)
        } else
            popUpForm = (
                <RevenueModalForm
                    tab={ action }
                    data={ row }
                    date={ new Date() }
                    ActionPerform={ (action, row) => this.ActionPerform(action, row) }
                    closePopup={ () => this.closePopup() } />
            )
        if (popUpForm) {
            this.setState({ popUpForm })
        }
    }

    /*  Para abrir o formulário de adição de valor para uma entidade selecionada  */

    addamountFrom = async (action, row) => {
        let Request = {}
        Request.entityId = parseInt(row.busEntidade.nifap);
        let link = "/Revenue/getEntityDetail"
        let res = await services.apiCall.requestApi(link, Request);
        if (res) {
            this.setState({
                entity_details: res
            }, () => this.updateNavDropdown(action, row));
        }
    }

    /*  Para abrir o pop-up com base na ação selecionada  */

    updateNavDropdown = (action, row, pageName = "faturasRecibos", forfutureInvoice = 0) => {
        const parsed = this.props.parsed;
        let popUpForm = (
            <RightPopModalForm
                closePopup={ () => this.closePopup() }
                date={ new Date() }
                tab={ action }
                userPage={ this.props.userPage }
                pageName={ pageName }
                forfutureInvoice={ forfutureInvoice }
                optionMenuArray={ servicesMenuArray }
                parsed={ parsed }
                updateServiceslist={ (list) => this.updateServiceslist(list) }
                completeData={ null }
                billing_address={ null }
                getCurrentGeneralAccount={ () => this.getCurrentGeneralAccount() }
                Invoice={ row }
                entity_details={ this.state.entity_details }
            />
        )
        this.setState({
            popUpForm
        })
    }

    GetInvoiceLink = async (checkedInvoice) => {
        let link = "/Revenue/GetInvoiceLink";
        let request = { invoice_id: checkedInvoice }
        let res = await services.apiCall.requestApi(link, request);
        if (res) {
            toast.success("Documentos criados com sucesso");
            this.setState({
                checkedInvoice: [],
                date: new Date()
            });
        }
    }


    /*  Para abrir pop-up para detalhes */

    openDetailPopUpForm = (row, action) => {

        let popUpForm = '';

        if (this.props.linkData.popUpTwoTabName && action === 'detailPopUpTwo') {
            popUpForm = (
                <RevenueModalForm tab={ this.props.linkData.popUpTwoTabName } data={ row } date={ new Date() } closePopup={ () => this.closePopup() } />
            )
        } else if (row.document_type == 'Credit') {
            popUpForm = (
                <RevenueModalForm
                    tab={ "Credit Details" }
                    data={ row }
                    date={ new Date() }
                    closePopup={ () => this.closePopup() }
                />
            )
        }
        else {
            popUpForm = (
                <RevenueModalForm
                    tab={ this.props.linkData.popUpTabName }
                    // tab={action}
                    data={ row }
                    date={ new Date() }
                    popUpForm2={ this.state.popUpForm2 }
                    updatePopUpFormDouble={ (action, row) => this.updatePopUpFormDouble(action, row) }
                    closePopup={ () => this.closePopup() }
                />
            )
        }
        this.setState({
            popUpForm
        })
    }


    /*  Para abrir pop-up em um pop-up */

    updatePopUpFormDouble = (popUpForm2) => {
        this.setState({
            popUpForm2
        })
        $("#firstPopup").trigger("click");
        $("#secondPopup").trigger("click");
    }

    /*  Para fechar pop-up  */

    closePopup = () => {
        this.getCurrentGeneralAccount();
        this.setState({
            date: new Date()
        });
        if (this.state.entity_details.busEntidade && this.state.entity_details.busEntidade.nifap) {
            this.getEntityDetails(this.state.entity_details.busEntidade.nifap)

        }
        $(".left-popup").trigger('click');
    }

    updateServiceslist = (list) => {
        this.props.updateServiceslist(list)
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div className="inner-container">
                <TitleBar
                    path={ this.props.linkData.FormInsertPath }
                    title={ this.props.linkData.TitleBartitle }
                    logo={ this.props.linkData.TitleBarlogo }
                    prevPageName={ this.props.linkData.prevPageName }
                    prevPageLink={ this.props.linkData.prevPageLink }
                    linkData={ this.props.linkData }
                    noOption={ true }
                    changeOption={ (mainIndex, subIndex) => this.props.changeOption(mainIndex, subIndex) } optionMenuArray={ this.props.optionMenuArray } />
                {
                    this.state.maxDate && 
                    <span>Última atualização (IVV) efetuada em ( {this.state.maxDate} )</span>
                }
                {
                    this.props.linkData.filters && Object.keys(this.props.linkData.filters).length > 0 &&
                    <SearchFilter 
                        optionText="Pesquisa por NIF ou Nome" // Marco em vez de Designação ficou Nome
                        installationNumber={ true }
                        filters={ this.props.linkData.filters }
                        //-clickLimparFilter={this.state.clickLimparFilter}
                        searchplaceholder={ "Pesquisa por Nº de Instalação IVDP ou Nome" } // Marco em vez de Designação ficou Nome
                        handleFilter={ (data) => this.handleFilter(data) }
                        getFilter={ (data) => this.getFilters(data) }
                        data={ this.state.data }
                        moduleType="TableIV"
                        
                    />
                }

                {/* {
                        <RevenueEntityAction
                            entity_details={this.state.entity_details}
                            closePopup={() => this.closePopup()}
                            Actionlist={{ valor: true, Movimento: false, recibo: false }}
                            date={new Date()}
                            parsed={this.props.parsed}
                            getEntityDetails={(id) => this.getEntityDetails(id)}
                            linkData={this.props.linkData}
                            pageName={this.props.tab}
                            general_balance={this.state.general_balance_row}
                        />
                    } */}
                {
                    this.state.general_balance_row && this.props.linkData && this.props.linkData.tableName === "general_account" && this.props.tab === "general_account" &&
                    <div className="tab-section col-md-12">
                        <div className="innerBox active cursor-pointer">
                            <div className="display-content">
                                <div className="row">
                                    <div className="col-md-9">
                                        <p><strong>Balanço Geral Atual:</strong></p>{ services.money.format(this.state.general_balance_row.balance) }
                                    </div>
                                    <div className="col-md-3">
                                        <Button data-toggle="modal" data-target="#vindima-modal" primary={ true } onClick={ () => this.updateNavDropdown('Add_General_Amount', "general_account") } className="btn-ivdp-primary mr-2 k-primary">Adicionar Conta Geral</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    //Object.keys(this.state.applyedfilter).length > 0  &&
                    <InstalaCaovinicaTables
                        date={ this.state.date }
                        tableName={ this.props.linkData.tableName }
                        showSearchMsg={this.state.showSearchMsg}
                        modificaoDateShow={(data)=>this.modificaoDateShow(data)}
                        applyedfilter={ this.state.applyedfilter }
                        ActionPerform={ (action, row) => this.ActionPerform(action, row) }
                        
                    />
                }
                <div className="modal left-popup" id="vindima-modal">
                    <div className="modal-dialog modal-lg">
                        {
                            this.state.popUpForm
                        }
                    </div>
                </div>
                <input type='hidden' data-toggle="modal" data-target="#vindima-modal" id="firstPopup" />
                <input type='hidden' data-toggle="modal" data-target="#leftdetailpopup" id="secondPopup" />
                <div className="modal left-popup left-popup2" id="leftdetailpopup">
                    <div className="modal-dialog modal-sm">
                        {
                            this.state.popUpForm2
                        }
                    </div>
                </div>
                {
                    <div>
                        <button className="hidden" data-toggle="modal" data-target="#revenuEntityactionpopup" id="revenuEntityactionpopupbutton"></button>
                        <div className="modal left-popup" id="revenuEntityactionpopup">
                            <div className="modal-dialog modal-lg">
                                {
                                    this.state.popUpForm
                                }
                            </div>
                        </div>
                    </div>
                }

            </div>
        )
    }
}


export default withRouter(Common);